import { HELP_ARTICLES_API } from '../constants'
import type { HelpArticleDetail, HelpArticleSummary } from '../types'

// These call the website-v2 help service (a different origin than lukita), so
// they use fetch directly rather than the lukita REST client. The endpoints are
// public and CORS-allowed for the app origin.

let catalogPromise: Promise<HelpArticleSummary[]> | null = null

async function requestCatalog(): Promise<HelpArticleSummary[]> {
  const response = await fetch(HELP_ARTICLES_API)
  if (!response.ok) {
    throw new Error(`Help articles request failed (${response.status})`)
  }
  const data = (await response.json()) as { articles: HelpArticleSummary[] }
  return data.articles
}

// The catalog is small and static, so load it once per session and share it.
export function fetchHelpArticles(): Promise<HelpArticleSummary[]> {
  if (!catalogPromise) {
    catalogPromise = requestCatalog().catch((error) => {
      catalogPromise = null
      throw error
    })
  }
  return catalogPromise
}

export async function fetchHelpArticle(
  slug: string,
): Promise<HelpArticleDetail> {
  const response = await fetch(
    `${HELP_ARTICLES_API}/${encodeURIComponent(slug)}`,
  )
  if (!response.ok) {
    throw new Error(
      `Help article "${slug}" request failed (${response.status})`,
    )
  }
  const data = (await response.json()) as { article: HelpArticleDetail }
  return data.article
}
